export default __webpack_public_path__ + "images/navigating-complexity-background.fb95717aa373a1be98b25baa58d7016a.png";